/** @jsxImportSource @emotion/react */
import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Button } from '@mui/material';
import { TitleWrap, AlertBtnGroup, diAlert } from 'components/layouts/Dialog';
import CustomInputWithSearch from 'components/inputs/CustomInputWithSearch';
import {
  SubTitleLayout,
  SubTitleGroup,
  HalfContetntLayout,
  ControlBtnGroup,
} from 'components/layouts/ContentLayout';
import {
  SearchBox,
  SearchBoxRow,
  InputBox,
  SearchRows,
  SearchCols,
} from 'components/layouts/SearchBox';
import { IconButton } from 'components/buttons/IconSVG';
import { getElmEmpList } from 'apis/common/ElmEmp';
import { getContInfoList } from 'apis/gtng/popup/GatingCont';
import { useTranslation } from 'react-i18next';
import CustomDialog from 'components/modals/common/CustomDialog';
import CustomGrid from 'components/grids/CustomGrid';
import SearchBoxButtons from 'components/buttons/SearchBoxButtons';

export interface contSearchParam {
  rowId?: string;
  gatingId?: string;
  userId?: string;
  empNm?: string;
  deptNm?: string;
  useYn?: string;
}

interface SearchParam {
  userId?: string;
  empNm?: string;
  deptNm?: string;
  useYn?: string;
}

/**
 * 사용자 찾기 팝업 : 등록/수정/삭제
 * 사용화면 : 게이팅 생성
 *
 * @param props
 * @constructor
 */
export const GatingContPopUp = (props: any) => {
  const { t } = useTranslation();
  const [contRetrieveList, setContRetrieveList] = useState<contSearchParam[]>([]);
  const [contChangeList, setContChangeList] = useState<contSearchParam[]>([]);
  const [searchParam, setSearchParam] = useState<SearchParam>({});
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  // gatingId는 존재하고 담당자는 등록 안되어있을때 실행되지않게 해야함.
  useEffect(() => {
    if (props.initParam != null && props.initParam != '') {
      const value = props.initParam;
      getContInfo(value);
    }
  }, [props.initParam]);

  const getElmEmpInfo = async (searchParam) => {
    await getElmEmpList(searchParam).then((result: any) => {
      if (result != null && result != undefined) {
        setContRetrieveList(result);
      }
    });
  };

  const getContInfo = async (value) => {
    await getContInfoList(value).then((result: any) => {
      if (result != null && result != '') {
        setContChangeList(result);
      }
    });
  };

  const handleSearchParam = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setSearchParam({
      ...searchParam,
      [name]: value,
    });
  };

  const btnAddRow = () => {
    const selectedRowNodes = contRetrieveListFlexRef.selectedRows;
    if (selectedRowNodes.length > 0) {
      const addData = selectedRowNodes.map((data) => {
        const newRow = {
          rowId: '',
          gatingId: props.initParam,
          userId: data.dataItem.userId,
          empNm: data.dataItem.empNm,
          deptNm: data.dataItem.deptNm,
          useYn: '',
        } as contSearchParam;
        return newRow;
      });
      const contLenght = contChangeList.length + addData.length;
      if (contLenght > 100) {
        setOpen(true);
      } else {
        setContChangeList(_.uniqBy(contChangeList.concat(addData), 'userId'));
      }
    }
  };

  const btnDelRow = useCallback(() => {
    const selectedRowNodes = contChangeListFlexRef.selectedRows;
    selectedRowNodes.forEach(function (item) {
      contChangeListFlexRef.collectionView.remove(item.dataItem);
    });
    const filteredData = contChangeList.filter((element) => element !== undefined);
    setContChangeList(filteredData);
  }, [contChangeList]);

  const btnUserSelectInfo = () => {
    const rowId = props.rowId; //props로 받아온 rowId
    const fieldId = props.fieldId; //props로 받아온 fieldId
    const contData = { contInfo: contChangeList, rowId: rowId, fieldId: fieldId };
    props.setContData(contData);
    props.setPopup(false);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      getElmEmpInfo(searchParam);
    }
  };

  const [contRetrieveListFlexRef, setContRetrieveListFlexRef] = useState<any>();
  const [contChangeListFlexRef, setContChangeListFlexRef] = useState<any>();

  const contRetrieveListLayoutDefinition = () => {
    return [
      {
        binding: 'no',
        header: String(t('com.label.NO', 'NO')),
        align: 'center',
        cellTemplate: (grid) => grid.row._idx + 1,
        width: 40,
      },
      {
        binding: 'userId',
        header: String(t('com.label.사용자ID', '사용자ID')),
        align: 'center',
        width: '*',
      },
      {
        binding: 'empNm',
        header: String(t('com.label.사용자명', '사용자명')),
        align: 'center',
        width: '*',
      },
      {
        binding: 'deptNm',
        header: String(t('com.label.부서명', '부서명')),
        align: 'left',
        width: '*',
      },
    ];
  };

  const contChangeListLayoutDefinition = () => {
    return [
      {
        header: 'id',
        binding: 'id',
        align: 'center',
        width: 40,
        visible: false,
      },
      {
        binding: 'no',
        header: String(t('com.label.NO', 'NO')),
        align: 'center',
        cellTemplate: (grid) => grid.row._idx + 1,
        width: 40,
      },
      {
        binding: 'userId',
        header: String(t('com.label.사용자ID', '사용자ID')),
        align: 'center',
        width: '*',
      },
      {
        binding: 'empNm',
        header: String(t('com.label.사용자명', '사용자명')),
        align: 'center',
        width: '*',
      },
      {
        binding: 'deptNm',
        header: String(t('com.label.부서명', '부서명')),
        align: 'left',
        width: '*',
      },
    ];
  };

  const contRetrieveListState = {
    itemsSource: contRetrieveList,
    layoutDefinition: contRetrieveListLayoutDefinition(),
  };

  const contChangeListState = {
    itemsSource: contChangeList,
    layoutDefinition: contChangeListLayoutDefinition(),
  };

  const contRetrieveListOnInitialized = (grid) => {
    setContRetrieveListFlexRef(grid);
  };

  const contChangeListOnInitialized = (grid) => {
    setContChangeListFlexRef(grid);
  };

  const dialogButtons = [
    <Button key={'select'} css={IconButton.button} className="select" onClick={btnUserSelectInfo}>
      {t('com.button.선택', '선택')}
    </Button>,
  ];

  return (
    <>
      <CustomDialog
        title={t('gtng.label.Gating 담당자 조회', 'Gating 담당자 조회')}
        open={true}
        onClose={() => props.close()}
        onCancel={() => props.close()}
        buttons={props.setReadonly ? undefined : dialogButtons}
      >
        <SearchBox>
          <SearchBoxRow>
            <InputBox>
              <SearchRows>
                <SearchCols>
                  <label>{t('com.label.사용자ID', '사용자ID')}</label>
                  <CustomInputWithSearch
                    type="text"
                    name="userId"
                    placeholder={String(
                      t('com.label.사용자ID를 입력해 주세요.', '사용자ID를 입력해 주세요.')
                    )}
                    value={searchParam.userId}
                    onChange={handleSearchParam}
                    onKeyDown={onKeyDown}
                  />
                </SearchCols>
                <SearchCols>
                  <label>{t('com.label.사용자명', '사용자명')}</label>
                  <CustomInputWithSearch
                    type="text"
                    name="empNm"
                    placeholder={String(
                      t('com.label.사용자명을 입력해 주세요.', '사용자명을 입력해 주세요.')
                    )}
                    value={searchParam.empNm}
                    onChange={handleSearchParam}
                    onKeyDown={onKeyDown}
                  />
                </SearchCols>
                <SearchCols>
                  <label>{t('gtng.label.부서명', '부서명')}</label>
                  <CustomInputWithSearch
                    type="text"
                    name="deptNm"
                    placeholder={String(
                      t('gtng.msg.부서명을 입력해 주세요.', '부서명을 입력해 주세요.')
                    )}
                    value={searchParam.deptNm}
                    onChange={handleSearchParam}
                    onKeyDown={onKeyDown}
                  />
                </SearchCols>
              </SearchRows>
              {/* <SearchCols>
                    <label>{t('com.label.사용여부', '사용여부')}</label>
                    <CustomSelect
                      value={searchParam.useYn}
                      name="useYn"
                      onChange={handleSearchParam}
                    >
                      <option value="">{t('com.label.전체', '전체')}</option>
                      <option value={CommonYN.Y}>{t('com.label.사용', '사용')}</option>
                      <option value={CommonYN.N}>{t('com.label.사용안함', '사용안함')}</option>
                    </CustomSelect>
                  </SearchCols> */}
            </InputBox>
            <SearchBoxButtons
              setReset={setSearchParam}
              onSearch={() => getElmEmpInfo(searchParam)}
            />
          </SearchBoxRow>
        </SearchBox>
        <HalfContetntLayout style={{ marginTop: '24px' }}>
          <div>
            <SubTitleLayout>
              <SubTitleGroup>
                <h3>{t('gtng.label.담당자 조회 결과', '담당자 조회 결과')}</h3>
                <span className="total">
                  {t('com.label.총', '총')}
                  <span>{(contRetrieveList || []).length.toLocaleString()}</span>
                  {t('com.label.건', '건')}
                </span>
              </SubTitleGroup>
              <ControlBtnGroup>
                <Button
                  css={IconButton.button}
                  className="addRow"
                  onClick={btnAddRow}
                  disableRipple
                >
                  {t('com.button.행추가', '행추가')}
                </Button>
              </ControlBtnGroup>
            </SubTitleLayout>
            <CustomGrid
              layoutDefinition={contRetrieveListState.layoutDefinition}
              rowData={contRetrieveListState.itemsSource}
              height={410}
              isReadOnly={true}
              isFilter={false}
              autoCheck={true}
              allowPinning={false}
              initialized={contRetrieveListOnInitialized}
            />
          </div>
          <div>
            <SubTitleLayout>
              <h3></h3>
              <ControlBtnGroup>
                <Button
                  css={IconButton.button}
                  className="delRow"
                  onClick={btnDelRow}
                  disableRipple
                >
                  {t('com.button.행삭제', '행삭제')}
                </Button>
              </ControlBtnGroup>
            </SubTitleLayout>
            <CustomGrid
              layoutDefinition={contChangeListState.layoutDefinition}
              rowData={contChangeListState.itemsSource}
              height={410}
              isReadOnly={true}
              isFilter={false}
              autoCheck={true}
              allowPinning={false}
              initialized={contChangeListOnInitialized}
            />
          </div>
        </HalfContetntLayout>
      </CustomDialog>
      {open ? (
        <Dialog open={true} onClose={handleClose} css={diAlert.dialog} fullWidth maxWidth={false}>
          <TitleWrap>
            <h2>{t('com.label.알림', '알림')}</h2>
            {/* 취소/확인을 하는 Alert는 "확인" 타이틀, "확인"만 하는 Alert는 "알림" 타이틀을 사용해주세요 */}
          </TitleWrap>
          <DialogContent>
            <div className="AlertContent">
              {t(
                'com.label.담당자를 더 이상 추가 할 수 없습니다.(100명 제한)',
                '담당자를 더 이상 추가 할 수 없습니다.(100명 제한)'
              )}
            </div>
          </DialogContent>
          <AlertBtnGroup>
            <Button className="ok" onClick={handleClose} disableRipple>
              <h2>{t('com.button.확인', '확인')}</h2>
            </Button>
          </AlertBtnGroup>
        </Dialog>
      ) : null}
    </>
  );
};
